import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Data, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { BeyAuthAsideBrandingComponent } from '../../components/bey-auth-aside-branding/bey-auth-aside-branding.component';
import { BeyAuthHeaderBrandingComponent } from '../../components/bey-auth-header-branding/bey-auth-header-branding.component';
import { RouterService } from '../../../core/services/router.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [BeyAuthHeaderBrandingComponent, RouterOutlet, BeyAuthAsideBrandingComponent, AsyncPipe],
})
export class AuthLayoutComponent implements OnInit {
  routeData$: Observable<Data>;

  constructor(private routerService: RouterService) {}

  ngOnInit(): void {
    this.routeData$ = this.routerService.routeData$;
  }
}
